export default "/fonts/ReverIcons.eot?e5abf455887390a3f6850efdff57be29";